import styles from "./index.module.less";
import { Flex } from "antd";
import p2Img from "./imgs/p2_img.png";
import p3Img from "./imgs/p3_img.png";
import P1Content from "@/components/P1Content";
import data from "../data";
import banner from "./imgs/p1_bg.png";

const MobileLive = () => {
  return (
    <div>
      <div className={styles.p1}>
        <P1Content
          title={data.p1.title}
          subtitle={data.p1.subtitle}
          link={data.p1.link}
          style={{
            backgroundImage: `url(${banner})`,
          }}
        />
      </div>
      <div className={styles.p2}>
        <div className={styles.p2_inner}>
          <Flex vertical gap={".36rem"}>
            <div className={styles.p2_title}>
              <div>{data.p2.title}</div>
              <div>
                <span>{data.p2.subtitle}</span>
              </div>
            </div>
            <img src={p2Img} />
            <div>
              {data.p2.desc.map((desc, i) => (
                <div className={styles.p2_desc} key={i}>
                  {desc}
                </div>
              ))}
            </div>
          </Flex>
        </div>
      </div>
      <div className={styles.p3}>
        <div className={styles.p3_inner}>
          <div className={styles.p3_title}>{data.p3.title}</div>
          <img src={p3Img} />
          <Flex
            align="center"
            justify="space-around"
            className={styles.steps}
            gap={".36rem"}
            wrap
          >
            {data.p3.steps.map((step, index) => (
              <Flex
                vertical
                align="center"
                key={index}
                className={styles.step}
                gap={".1rem"}
              >
                <div className={styles.step_index}>{`0${index + 1}`}</div>
                <div className={styles.step_text}>{step}</div>
              </Flex>
            ))}
          </Flex>
        </div>
      </div>
    </div>
  );
};
export default MobileLive;
